import PropTypes from "prop-types";

import Row from "../Row";
import React from "react";
import Tools from "../../../helpers/tools";
import _ from "lodash";

const ConnectedServicesRows = ({connectedStatus, privacy}) => {
    const {L1, L3, status, ecallOnly} = connectedStatus;
    const isPrivacyModeEnabled = _.get(privacy, `isPrivacyModeEnabled`, undefined);
    return _.isEmpty(status) ? `` :
        (
        <>
            <Row label={`Connected Services`} empty/>
            <Row label={`Privacy mode`}
             value={isPrivacyModeEnabled !== undefined && L3 && Tools.booleanToString(isPrivacyModeEnabled)}
             indented>
                {
                    isPrivacyModeEnabled === undefined || !L3 ?
                        <span
                            className={`fa fa-info-circle vehicle-connected`}
                            aria-hidden="true"
                            title={`Privacy mode can only be enabled if the customer has active connected services`}
                        /> : ``
                }
            </Row>
            <Row label={`Device installed and ready`} value={Tools.booleanToString(L1)} indented/>
            <Row label={`Connected Services Active`} value={Tools.booleanToString(L3)} indented>
                {
                    L3 ?
                        <span
                            className={`fa fa-info-circle vehicle-connected`}
                            aria-hidden="true"
                            title={`linked with customer and device is active`}
                        /> : ``
                }
            </Row>
            <Row label={`Status`} value={status} indented/>
            <Row label={`Ecall only`} value={ecallOnly !== undefined && Tools.booleanToString(ecallOnly)} indented/>
        </>
    );
};

ConnectedServicesRows.displayName = `ConnectedServicesRows`;
ConnectedServicesRows.propTypes = {
    connectedStatus : PropTypes.object.isRequired,
    privacy : PropTypes.object.isRequired
};
export default ConnectedServicesRows;